import $http from "../../axios";
import {
    h
} from 'vue'
import {
    Notification,
    MessageBox
} from "element-ui";


export async function getWallet({
    state,
    commit
}, params) {
    state.loading.wallet = true;
    state.params.seller_id = params.seller_id
    state.params.contact_id = params.contact_id
    state.params.account_id = params.account_id
    state.params.wallet_type = params.wallet_type
    state.params.contact_warehouse_id = params.contact_warehouse_id

    await $http.get("/api/consulta-cartera", {
            params: state.params
        })
        .then(response => {
            commit('setwallet', response.data)
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
    state.loading.wallet = false;
}

export async function getPaysAndWallet({
    state,
    commit
}, params) {
    state.loading.pay = true;
    state.params.seller_id = params.seller_id
    state.params.contact_id = params.contact_id
    state.params.account_id = params.account_id
    state.params.wallet_type = 24605 // solo C X P
    state.params.contact_warehouse_id = params.contact_warehouse_id

    await $http.get("/api/consulta-pagos-cartera", {
            params: state.params
        })
        .then(response => {
            commit('setwallet', response.data)
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
    state.loading.pay = false;
}

export async function getAccountBank({
    state,
    commit
}) {

    await $http.get("/api/consulta-cuentas-bancarias")
        .then(response => {
            commit('setbankaccount', response.data)
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
    state.loading.wallet = false;
}

export async function fetchWalletType({
    commit,
    state
}, ) {
    await $http
        // .get("/api/parametros-por-tabla/100")
        .get("/api/parametros-por-codigo/C-004")
        .then(response => {
            commit("setWalletType", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

export async function getTransactions({
    state,
    commit
}, data) {
    await $http.get("/api/transacciones-cartera/" + data[0], {
            params: data[1]
        })
        .then(response => {
            commit('settransactions_wallet', response.data.data)
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function updateTracing({
    commit,
    state
}, attributs) {
    await $http
        .get("/api/actualizar-seguimiento", {
            params: attributs
        })
        .then(response => {
            commit('update_document', response.data[0]);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

export async function updatePay({
    commit,
    dispatch,
    state
}, attributs) {
    await $http
        .get("/api/actualizar-pagos", {
            params: attributs
        })
        .then(response => {
            commit('update_document', response.data[0]);
            dispatch('getPaysAndWallet', {
                contact_id: null,
                account_id: null,
                seller_id: null,
                wallet_type: null,
                contact_warehouse_id: null,
            })
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

export async function downloadDocument({
    state
}, documentToPdf) {
    state.loading.download_pdf = true
    let name = documentToPdf.code_voucher_type + ' No. ' + documentToPdf.consecutive + '.pdf'

    let url = ''


    if (state.params.wallet_type === 24605) {
        url = '/api/descargar-pdf-contabilidad/' + documentToPdf.affects_document_id
    } else {
        url = '/api/documentos/descargar-pdf/' + documentToPdf.affects_document_id
    }


    await $http({
        url: url,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    })
    state.loading.download_pdf = false
}

export async function sendEmailMasiveWallet({
    commit,
    state
}) {
    console.log(state.params);
    await $http.post('/api/enviando-masivo-correos', {
            params: state.contacs_selecteds
        })
        .then((response) => {
            console.log(response.data.data);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: 'Error',
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}

export async function aceptPay({
    commit,
    state,
    dispatch
}, params) {
    await $http.post('/api/aceptar-pagos', params)
        .then((response) => {
            Notification.success({
                title: 'Exito!',
                message: 'Pago aceptado con exito',
                type: "success",
                duration: 2000,
                customClass: 'notification-box',
            });
            dispatch('getPaysAndWallet', {
                contact_id: null,
                account_id: null,
                seller_id: null,
                wallet_type: null,
                contact_warehouse_id: null,
            })
        })
        .catch((error) => {
            let data = error.response.data
            Notification.error({
                title: 'Error!',
                message: data.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });

            MessageBox.alert(
                data.message,
                "Error", {
                    confirmButtonText: "Aceptar",
                    type: "error",
                    customClass: "notification-error"
                }
            );
        })
}

export async function verifyPay({
    commit,
    state,
    dispatch
}, params) {
    await $http.post('/api/verificar-pagos', params)
        .then((response) => {
            Notification.success({
                title: 'Exito!',
                message: 'Pago aceptado con exito',
                type: "success",
                duration: 2000,
                customClass: 'notification-box',
            });
            dispatch('getPaysAndWallet', {
                contact_id: null,
                account_id: null,
                seller_id: null,
                wallet_type: null,
                contact_warehouse_id: null,
            })
        })
        .catch((error) => {
            let data = error.response.data
            Notification.error({
                title: 'Error!',
                message: data.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });

            MessageBox.alert(
                data.message,
                "Error", {
                    confirmButtonText: "Aceptar",
                    type: "error",
                    customClass: "notification-error"
                }
            );
        })
}

export async function loadXml({
    commit,
    state,
    dispatch
}) {
    let formData = new FormData();
    state.params.files.map(fn => {
        formData.append("filesUpload[]", fn);
    });

    await $http.post('/api/cargar-xml', formData)
        .then((response) => {
            Notification.success({
                title: 'Exito!',
                message: 'xml cardgado con exito',
                type: "success",
                duration: 2000,
                customClass: 'notification-box',
            });
            dispatch('getPaysAndWallet', {
                contact_id: null,
                account_id: null,
                seller_id: null,
                wallet_type: null,
                contact_warehouse_id: null,
            })
        })
        .catch((error) => {
            let data = error.response.data
            Notification.error({
                title: 'Error!',
                message: data.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });

            MessageBox.alert(
                data.message,
                "Error", {
                    confirmButtonText: "Aceptar",
                    type: "error",
                    customClass: "notification-error"
                }
            );

            // modal de parametrizacion de proveedor
            if (data.data && data.data.error_cw) {
                state.modalTc.show = true
                state.modalTc.cw_id = data.data.cw_id
            }
        })
}

//Obtener las bodegas
export async function fetchBranchOfficeWarehouses({
    commit,
    state
}, brancheoffice) {
    await $http.get(`/api/bodegas-sedes?id=${brancheoffice}`)
        .then((response) => {
            commit('setBranchofficeWarehouses', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}

//Obtener Select de Conceptos Tabla FE02
export async function fetchConcepts({
    commit,
    state
}, ) {
    await $http
        // .get("/api/parametros-por-tabla/120")
        .get("/api/parametros-por-codigo/FE02")
        .then(response => {
            commit("setConcepts", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

//Obtener Conceptos Parametria Oficina
export async function fetchConceptsParameter({
    commit,
    state
}, contact_warehouse_id) {
    await $http
        .get("/api/parametria-sucursal-modelo/" + contact_warehouse_id)
        .then(response => {
            commit("setParameterContactWarehouse", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

//Eliminar Conceptos Parametria Oficina
export async function deleteParameterContactBd({
    commit,
    state
}, id_parameter_contact) {
    await $http
        .post("/api/delete-parametria-sucursal-modelo/" + id_parameter_contact)
        .then(response => {
            Notification.error({
                title: "Info!",
                message: "Parametro Eliminado Correctamente",
                type: "info",
                duration: 1500,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

//Obtener Conceptos Parametria Oficina
export async function fetchConceptsParameters({
    commit,
    state
}, contact_provider_id) {
    await $http
        .get("/api/provider-contact-parameters/" + contact_provider_id)
        .then(response => {
            commit("setConceptsParameters", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

export async function downFilesBank({
    state,
    commit
}) {

  /*ENVIO INFO BANCOLOMBIA */
  let wallet_filter_bancolombia = state.wallet.filter(wallet => wallet.passed === true && wallet.code_bank === '01');

    let parameters_excel_bancolombia = {};

    var new_wallet_filter_bancolombia = wallet_filter_bancolombia.map(function (wallet) {
        var objNecesary = {};
        objNecesary['affects_document_id'] = wallet.affects_document_id;
        objNecesary['passed'] = wallet.passed;
        objNecesary['value_pay'] = wallet.value_pay;
        objNecesary['cw_id'] = wallet.cw_id;
        objNecesary['document_affect'] = wallet.document_affect;
        objNecesary['id_account_bank'] = wallet.id_account_bank;
        return objNecesary;
    });




    for (var i = 0; i < new_wallet_filter_bancolombia.length; i++) {
        parameters_excel_bancolombia[i] = new_wallet_filter_bancolombia[i];
    }
    /*CREACION ARCHIVO BANCOLOMBIA*/

    let parms_excel_bancolombia = {
      ...parameters_excel_bancolombia
  };

    var bancolombia = await $http.post(`/api/verificar-proveedor`, {
        params: parameters_excel_bancolombia,
    });

    if (bancolombia.data[0] && bancolombia.data[0].error) {
        let message = "";
        let errors_bancolombia = Object.values(bancolombia.data);

        errors_bancolombia.map(function (error) {
            message += "El Proveedor <b>" + error.identification + "-" + error.name + "</b> :<br>" + error.error + "<br><br>";
        });

        MessageBox.alert(
            message,
            "Error Archivo Bancolombia", {
                confirmButtonText: "Aceptar",
                type: "error",
                customClass: "notification-error width-hom",
                dangerouslyUseHTMLString: true,
            }
        );



    } else {
      await $http({
        url: `/api/descargar-documento-bancolombia`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(parms_excel_bancolombia),
        responseType: 'blob', // important
    }).then(response => {

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'bancolombia.xlsx'); //or any other extension
        document.body.appendChild(link);
        link.click();
        commit('setLoading', false)

    }).catch((error) => {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: 'error',
            duration: 1500,
            customClass: 'notification-box'
        });
    })
    }


    /*ENVIO INFO BANCO DE BOGOTA */
    let wallet_filter_bancodebogota = state.wallet.filter(wallet => wallet.passed === true && wallet.code_bank === '02');

    let parameters_excel_bancodebogota = {};

    var new_wallet_filter_bancodebogota = wallet_filter_bancodebogota.map(function (wallet) {
        var objNecesary = {};
        objNecesary['affects_document_id'] = wallet.affects_document_id;
        objNecesary['passed'] = wallet.passed;
        objNecesary['value_pay'] = wallet.value_pay;
        objNecesary['cw_id'] = wallet.cw_id;
        objNecesary['document_affect'] = wallet.document_affect;
        objNecesary['id_account_bank'] = wallet.id_account_bank;
        return objNecesary;
    });


    for (var i = 0; i < new_wallet_filter_bancodebogota.length; i++) {
        parameters_excel_bancodebogota[i] = new_wallet_filter_bancodebogota[i];
    }

    let parms_excel_bogota = {
        ...parameters_excel_bancodebogota
    };
    /*CREACION ARCHIVO bancodebogota*/

    var bancodebogota = await $http.post(`/api/verificar-proveedor`, {
        params: parameters_excel_bancodebogota,
    });

    if (bancodebogota.data[0] && bancodebogota.data[0].error) {
        let message = "";
        let errors_bogota = Object.values(bancodebogota.data);

        errors_bogota.map(function (error) {
            message += "El Proveedor <b>" + error.identification + "-" + error.name + "</b> :<br>" + error.error + "<br><br>";
        });


        MessageBox.alert(
            message,
            "Error Archivo Banco de Bogota", {
                confirmButtonText: "Aceptar",
                type: "error",
                customClass: "notification-error width-hom",
                dangerouslyUseHTMLString: true,
            }
        );



    } else {
        await $http({
            url: `/api/descargar-documento-bancobogota`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(parms_excel_bogota),
            responseType: 'blob', // important
        }).then(response => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'bancodebogota.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();
            commit('setLoading', false)

        }).catch((error) => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        })
    }



}

export async function fetchFunctions({
    commit,
    state
}) {
    await $http
        // .get("/api/parametros-por-tabla/122")
        .get("/api/parametros-por-codigo/074")
        .then(response => {
            commit("setFunctions", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

export async function declinePay({
    commit,
    state,
    dispatch
}, params) {
    await $http.post('/api/rechazar-pagos', params)
        .then((response) => {
            Notification.success({
                title: 'Exito!',
                message: 'Pago rechazado con exito',
                type: "success",
                duration: 2000,
                customClass: 'notification-box',
            });
            dispatch('getPaysAndWallet', {
                contact_id: null,
                account_id: null,
                seller_id: null,
                wallet_type: null,
                contact_warehouse_id: null,
            })
        })
        .catch((error) => {
            let data = error.response.data
            Notification.error({
                title: 'Error!',
                message: data.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });

            MessageBox.alert(
                data.message,
                "Error", {
                    confirmButtonText: "Aceptar",
                    type: "error",
                    customClass: "notification-error"
                }
            );
        })
}
export async function fetchVouchertypeA({state, commit}){
    let brachOffice = Number(localStorage.selected_branchoffice)
    await $http.get("/api/tipos-de-comprobantes", {
        params: {
            paginate: false,
            filter: null,
            branchoffice: brachOffice,
        }
    })
    .then((response) => {
        commit('setGEVouchers_types', response.data.data)
    })
    .catch((error) => {
        Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box",
        });
    });
}

export async function generateExpenses({state,commit}){
    let params = state.form_generate_expenses;

    await $http.post('/api/generar-egresos', params)
    .then((response) => {
        Notification.success({
            title: 'Exito!',
            message: response.data.message,
            type: "success",
            duration: 2000,
            customClass: 'notification-box',
        });

        commit('setCreatedDocuments', response.data.data)
    })
    .catch((error) => {
        let data = error.response.data
        Notification.error({
            title: 'Error!',
            message: data.message,
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });

        MessageBox.alert(
            data.message,
            "Error", {
                confirmButtonText: "Aceptar",
                type: "error",
                customClass: "notification-error"
            }
        );
    })
}

export async function notifyBanks({state,commit}){
    await $http.get('/api/notificar-para-bancos')
    .then((response) => {
        console.log(response);
        MessageBox.alert(
            response.data.message,
            "Exito", {
                confirmButtonText: "Aceptar",
                type: "success",
            }
        );
    })
    .catch((error) => {
        let data = error.response.data
        Notification.error({
            title: 'Error!',
            message: data.message,
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });

        MessageBox.alert(
            data.message,
            "Error", {
                confirmButtonText: "Aceptar",
                type: "error",
                customClass: "notification-error"
            }
        );
    })
}
export async function getTracings({state,commit},obtener_seguimientos){
    state.tracings = [];
    await $http.get('/api/obtener-seguimientos/'+obtener_seguimientos)
    .then((response) => {
        commit('setTracings', response.data)
    })
    .catch((error) => {
        let data = error.response.data
        Notification.error({
            title: 'Error!',
            message: data.message,
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}
export async function addTracings({state,commit}){
    await $http.post('/api/nuevo-seguimiento' , state.tracing_fields)
    .then(async (response) => {
        commit('setTracings', response.data.data)
        state.tracing_fields.tracing = null;
    })
    .catch((error) => {
        let data = error.response.data
        Notification.error({
            title: 'Error!',
            message: data.message,
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    }).finally(() => {
       commit('setIsLockRecordButton');
    });
}

export async function deleteTracings({state,commit},id){
    await $http.delete('/api/eliminar-seguimiento/'+id)
    .then(async (response) => {
        commit('setTracings', response.data.data)
        Notification.success({
            title: 'Success!',
            message: response.data.message,
            type: 'success',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
    .catch((error) => {
        let data = error.response.data
        Notification.error({
            title: 'Error!',
            message: data.message,
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}
export async function getSubscriber({commit, dispatch, state}) {
    await $http.get('/api/suscriptor')
        .then(response => {
            commit('setSubscriber', response.data.data);
      })
      .catch(error => {
          console.error(error);
      });
}



// WEBPACK FOOTER //
// ./src/modules/receivable-report/actions.js